module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.examData), function(exam, i) {
    return _c('div', {
      key: 'exam-data-' + i,
      staticClass: "col-sm-8"
    }, [_c('h3', [_vm._v("Pregled reševanja  " + _vm._s(exam.class.name) + " za Izpit " + _vm._s(exam.exam.title) + ", ki se začne ob " + _vm._s(_vm._f("formatDate")(_vm.humanize(exam.startsAt))))]), _vm._v(" "), _vm._l((exam.events), function(eve) {
      return _c('div', {
        key: eve.id
      }, [_vm._v("\n        \n        " + _vm._s(eve.user.firstName) + " " + _vm._s(eve.user.lastName) + " " + _vm._s(eve.user.studentId) + " je oddal odgovor na vprašanje " + _vm._s(eve.correct) + " ob " + _vm._s(_vm._f("formatDate")(eve.createdAt)) + " \n      ")])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Prisotnih študentov: " + _vm._s(_vm.usersSolving.length))]), _vm._v(" "), _vm._l((_vm.usersSolving), function(user, i) {
    return _c('div', {
      key: 'user-' + user.id
    }, [_vm._v("\n        " + _vm._s(user.firstName) + " " + _vm._s(user.lastName) + " " + _vm._s(user.lastName) + " " + _vm._s(user.studentId) + "\n      ")])
  })], 2)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3014b29f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3014b29f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/SolvingExam.vue
// module id = 1394
// module chunks = 1